module.exports = __webpack_public_path__ + "static/tri-1-5bdc86af91ff1de54b3938a19379cac8.jpg";